import React from 'react';
import './SelfRegisteredAgents.css';

const SelfRegistrationOnboarding = ({
  profile,
  onGoToKyc,
  compact = false
}) => {
  if (!profile?.selfRegistered) return null;

  const statusLabel = profile.accountStatusLabel || 'IRA licence not uploaded';
  const reviewEligible = !!profile.reviewEligible;
  const approved = String(profile.kycStatus || '').toLowerCase() === 'approved';
  const declined = String(profile.kycStatus || '').toLowerCase() === 'rejected';
  const steps = Array.isArray(profile.steps) && profile.steps.length
    ? profile.steps.map((step) => ({
      key: step.key,
      title: step.key === 'wait_review' && !approved
        ? (reviewEligible
          ? 'Credit Control can now review your IRA licence'
          : 'Upload your IRA licence so Credit Control can review')
        : step.title,
      done: !!step.complete
    }))
    : [];

  return (
    <div className={`self-reg-onboarding ${compact ? 'compact' : ''}`}>
      <div className="self-reg-onboarding-header">
        <div>
          <h3>Upload your IRA licence</h3>
          <p>
            Your account is ready to use. Please upload your IRA licence from Profile → KYC Verification.
            Credit Control can review after it is uploaded.
            Current status: <strong>{declined ? 'Declined' : (approved ? 'Approved' : statusLabel)}</strong>
          </p>
        </div>
        {onGoToKyc && !approved && (
          <button type="button" className="self-reg-onboarding-btn" onClick={onGoToKyc}>
            Upload IRA licence
          </button>
        )}
      </div>
      <ol className="self-reg-onboarding-steps">
        {steps.map((step, index) => (
          <li key={step.key} className={step.done ? 'done' : ''}>
            <span className="step-index">{step.done ? '✓' : index + 1}</span>
            <span>{step.title}</span>
          </li>
        ))}
      </ol>
      {profile.kycReviewNotes && (approved || declined) && (
        <p className="self-reg-onboarding-notes">Review notes: {profile.kycReviewNotes}</p>
      )}
    </div>
  );
};

export default SelfRegistrationOnboarding;
